export default "__VITE_ASSET__QCuUliVR__"